import template from './permissionsForm.html';
import './permissionsForm.scss';

export class PermissionsFormController {
  constructor(appResizableAreas) {
    'ngInject';

    this.appResizableAreas = appResizableAreas;

    this._resizingSubscription = {
      remove: () => {},
      update: () => {},
    };
  }
  $postLink() {
    this._resizingSubscription = this.appResizableAreas.listen('permissionsForm');
  }
  $onDestroy() {
    this._resizingSubscription.remove();
  }
  onBrandsAutocompleteSearch(text) {
    this.onAutocompleteSearch({
      name: 'brands',
      text,
    });
  }
  onBrandsAutocompleteSelect(entity) {
    this.onAutocompleteSelection({
      name: 'brands',
      selection: entity,
    });
  }
  onToggleBrandsPillsVisibility() {
    this.onTogglePillsVisibility({ name: 'brands' });
  }
  removeBrandsPill(pill) {
    this.onRemovePill({
      name: 'brands',
      selection: pill,
    });
  }
  onUsersAutocompleteSearch(text) {
    this.onAutocompleteSearch({
      name: 'users',
      text,
    });
  }
  onUsersAutocompleteSelect(entity) {
    this.onAutocompleteSelection({
      name: 'users',
      selection: entity,
    });
  }
  onToggleUsersPillsVisibility() {
    this.onTogglePillsVisibility({ name: 'users' });
  }
  removeUsersPill(pill) {
    this.onRemovePill({
      name: 'users',
      selection: pill,
    });
  }
  selectScope(item) {
    this.onScopeSelection({ scope: item });
    this._resizingSubscription.update();
  }
  selectRole(item) {
    this.onRoleSelection({ role: item });
    this._resizingSubscription.update();
  }
  togglePermission($event, permission) {
    if (this.readOnly) {
      $event.preventDefault();
    } else {
      this.onPermissionToggle({
        permission,
        isSelected: this.isPermissionsSelected(permission),
      });
    }
  }
  isPermissionsSelected(permission) {
    return !!this.selectedPermissions.find((item) => item.id === permission.id);
  }
  toggleList() {
    this.onPermissionsListToggle();
  }
}

export default {
  controller: PermissionsFormController,
  template,
  bindings: {
    readOnly: '<',

    loading: '<',
    loadingList: '<',

    ownerLabel: '@',
    ownerCaption: '<',

    showSave: '<',
    saveText: '@',
    onSave: '&',
    disableSave: '<',

    onCancel: '&',

    brands: '<',
    showBrands: '<',
    showAllBrands: '<',
    canAddBrands: '<',
    canRemoveAllBrands: '<',
    autocompleteBrandsResults: '<',

    users: '<',
    showUsers: '<',
    showAllUsers: '<',
    canAddUsers: '<',
    canRemoveAllUsers: '<',
    autocompleteUsersResults: '<',

    scopes: '<',
    selectedScope: '<',
    disableScopes: '<',
    onScopeSelection: '&',

    roles: '<',
    selectedRole: '<',
    disableRoles: '<',
    usingCustomRole: '<',
    onRoleSelection: '&',

    permissions: '<',
    selectedPermissions: '<',
    togglePermissionsAll: '<',
    onPermissionToggle: '&',
    onPermissionsListToggle: '&',

    onAutocompleteSearch: '&',
    onAutocompleteSelection: '&',

    onTogglePillsVisibility: '&',
    onRemovePill: '&',
  },
};
